import CDSConfig from '../model/CDSConfig';
import CDSResponse from '../model/CDSResponse';
import CDSPublication from '../model/CDSPublication';

export default class CDSParser {

    parseCDSConfig(data) {

        let cdsConfig = new CDSConfig();

        let xml = $(data);
        let node = xml.children().first();

        cdsConfig.cdsUrl = node.children('ns2\\:cdsUrl').text();
        cdsConfig.cdsLibraryId = node.children('ns2\\:cdsLibraryId').text();
        cdsConfig.cdsUseDefaultUsername = (node.children('ns2\\:cdsUseDefaultUsername').text() == "true");

        return cdsConfig;
    }

    parseCDSResponse(data) {

        let cdsResponse = new CDSResponse();

        let xml = $(data);
        let nodeResult = xml.children().first();

        cdsResponse.code = nodeResult.attr('code');
        cdsResponse.message = nodeResult.attr('message');

        let nodePublications = nodeResult.children('publications');
        nodePublications.children('publication').each((i, elem) => {
            let nodePublication = $(elem);
            let cdsPublication = new CDSPublication();

            cdsPublication.id = nodePublication.attr('id');
            cdsPublication.name = nodePublication.attr('name');
            cdsPublication.recursive = (nodePublication.attr('recursive') == "true");

            cdsResponse.publications[cdsPublication.id] = cdsPublication;
        });

        return cdsResponse;
    }

}
